/** @format */

import { Container } from "../../components/layouts/Container";
import BcartEconomicEstimateElement from "../../components/ui_elements/bcart/Economic/EconomicEstimateElement";

const BcartEconomicEstimate = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"}>
      <BcartEconomicEstimateElement redirect={redirect} />
    </Container>
  );
};

export default BcartEconomicEstimate;
